import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

import "./PricingPlans.css";


const PricingPlans = () => {

  const navigate = useNavigate();


  return (

    <section className="pricing-plans-section">


      {/* =========================
          HERO
      ========================== */}

      <div className="hero-section-professional">

        <h1 className="hero-title-professional">
          Alege planul potrivit pentru tine
        </h1>

        <p className="hero-subtitle-professional">
          Invata contabilitatea prin lectii interactive,
          quiz-uri, jocuri si aplicatii practice.
        </p>

      </div>



      {/* =========================
          PRICING
      ========================== */}

      <div className="pricing-container-professional">


        {/* =========================
            GRATUIT
        ========================== */}

        <div className="pricing-card-professional free-plan">

          <div className="plan-header-professional">

            <h3 className="plan-name-professional">
              Gratuit
            </h3>


            <div className="plan-price-professional">

              <span className="price-amount-professional">
                0
              </span>

              <span className="price-currency-professional">
                LEI
              </span>

            </div>


            <p className="plan-description-professional">
              Descopera ContaLearn fara costuri
            </p>

          </div>


      


          <button
            type="button"
            className="plan-button-professional outline"
            onClick={() => navigate("/viewplans")}
          >
            Vezi detalii
          </button>

        </div>



        {/* =========================
            PREMIUM LUNAR
        ========================== */}

        <div className="pricing-card-professional">

          <div className="plan-header-professional">

            <h3 className="plan-name-professional">
              Premium Lunar
            </h3>


            <div className="plan-price-professional">

              <span className="price-amount-professional">
                39
              </span>

              <span className="price-currency-professional">
                LEI/luna
              </span>

            </div>


            <p className="plan-description-professional">
              Flexibilitate maxima, fara plata pe termen lung
            </p>

          </div>


     


          <button
            type="button"
            className="plan-button-professional"
            onClick={() => navigate("/viewplans")}
          >
            Vezi detalii
          </button>


        

        </div>



        {/* =========================
            PREMIUM 3 LUNI
        ========================== */}

        <div className="pricing-card-professional">

          <div className="plan-header-professional">

            <h3 className="plan-name-professional">
              Premium 3 Luni
            </h3>


            <div className="plan-price-professional">

              <span className="price-amount-professional">
                99
              </span>

              <span className="price-currency-professional">
                LEI/3 luni
              </span>

            </div>


            <p className="plan-description-professional">
              Doar <strong>33 LEI/luna</strong>
            </p>

          </div>


       


          <button
            type="button"
            className="plan-button-professional primary"
            onClick={() => navigate("/viewplans")}
          >
            Vezi detalii
          </button>


         

        </div>


      </div>

    </section>

  );

};


export default PricingPlans;